// removed by extract-text-webpack-plugin
module.exports = {"formTitle":"_2GC92CambHC2M4twDJxoIG","formLabel":"A_yr45CjWLD4qctYIcmML","formControl":"_37EVg1DCYobdvLgvJ8Fi61","saveButton":"oIzGqQiDf6ncymUmqVsaM","cancelButton":"_1UGxVHKC4i8g3QNFkYCmIL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/Step2.css
// module id = 847
// module chunks = 0